import { GridItem } from '../../../components/ui/grid-item'

type Props = {
  createdAt: string
  href: string
  title: string
  type: string
}

function OutreachGridItem({ createdAt, href, title, type }: Props) {
  return (
    <GridItem createdAt={createdAt} href={href} title={title} type={type} />
  )
}

export { OutreachGridItem }
